import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      brand: { tagline: "The premium marketplace for cards & sealed collectibles." },
      common: {
        search: "Search cards, sets, sellers...",
        sell: "Sell",
        login: "Log in",
        register: "Sign up",
        logout: "Log out",
        profile: "Profile",
        admin: "Admin",
        favorites: "Favorites",
        loading: "Loading...",
        save: "Save",
        cancel: "Cancel",
        apply: "Apply",
        clear: "Clear",
        next: "Next",
        back: "Back",
        publish: "Publish listing",
        all: "All",
        yes: "Yes",
        no: "No",
        optional: "optional",
        view_all: "View all",
        showing: "Showing {{count}} of {{total}}",
        no_results: "No listings found. Adjust your filters or try a different search.",
        confirm: "Confirm",
      },
      nav: { browse: "Browse", sealed: "Sealed", graded: "Graded", sports: "Sports", tcg: "TCG" },
      home: {
        hero_kicker: "Cardlon — Collector-grade marketplace",
        hero_title: "Trade cards & sealed product with confidence.",
        hero_sub: "Pokemon, Magic, Yu-Gi-Oh, Lorcana, One Piece, sports cards & more — verified sellers, authentic ratings, transparent grading.",
        cta_browse: "Browse marketplace",
        cta_sell: "Start selling",
        section_categories: "Categories",
        section_featured: "Newest listings",
        section_popular: "Popular now",
        popular_sub: "Most favorited listings by the community.",
        no_popular_yet: "No popular listings yet. Be the first to list!",
        no_listings_yet: "No listings yet. Be the first to list a card!",
        stat_listings: "Active listings",
        stat_users: "Collectors",
        stat_tx: "Completed sales",
      },
      browse: {
        title: "Browse marketplace",
        filters: "Filters",
        category: "Category / TCG / Sport",
        any_category: "Any category",
        language: "Language",
        condition: "Condition",
        price_range: "Price range (€)",
        graded: "Graded",
        grading_firm: "Grading firm",
        grade: "Grade",
        sealed: "Sealed",
        location: "Location",
        shipping: "Shipping available",
        account_type: "Seller type",
        private: "Private",
        commercial: "Commercial",
        verified_only: "Verified sellers only",
        sort: "Sort",
        sort_newest: "Newest",
        sort_popular: "Popular",
        sort_price_asc: "Price ↑",
        sort_price_desc: "Price ↓",
        results: "Results",
      },
      card: {
        graded: "Graded",
        sealed: "Sealed",
        verified: "Verified",
        case_fresh: "Case fresh",
        first_ed: "1st Ed.",
        seller: "Seller",
        rating: "Rating",
      },
      listing: {
        details: "Details",
        description: "Description",
        buy: "Buy now",
        buy_request: "Send buy request",
        contact: "Open chat",
        owner_hint: "You are the seller. Buyers will appear here and you can confirm sales in the chat.",
        favorite: "Save",
        favorited: "Saved",
        shipping_cost: "Shipping",
        total: "Total",
        seller_info: "About the seller",
        response_time: "Response time",
        location: "Location",
        member_since: "Member since",
        reviews: "reviews",
        positive_pct: "positive",
        condition: "Condition",
        language: "Language",
        edition: "Edition",
        variant: "Variant",
        year: "Year",
        set: "Set",
        number: "Number",
        rarity: "Rarity",
        grading: "Grading",
        grading_firm: "Grading firm",
        grade: "Grade",
        serial: "Serial number",
        cert_link: "Certificate",
        slab_condition: "Slab condition",
        label_notes: "Label notes",
        subgrades: "Subgrades",
        category: "Category",
        product_name: "Product name",
        quantity: "Quantity",
        ean: "EAN / Barcode",
        first_edition: "First edition",
      },
      wizard: {
        title: "Create a listing",
        quota_used: "listings this month",
        quota_premium: "Premium · unlimited",
        upgrade: "Upgrade",
        upgrade_for_more: "Upgrade to Premium for up to 10 images",
        image_limit: "{{used}} / {{max}} images",
        image_limit_reached: "Image limit reached — upgrade to add more",
        ai_scan_title: "Scan a card with AI",
        ai_scan_sub: "Take or upload a photo of the card. We'll auto-detect name, set, edition, language, and grading info.",
        ai_scan_cta: "Photograph / Upload card",
        ai_scanning: "Recognizing…",
        step_type: "Type",
        step_card: "Card",
        step_grading: "Grading",
        step_images: "Images",
        step_price: "Price & shipping",
        step_review: "Review",
        choose_type: "What are you selling?",
        single_card: "Single card",
        sealed_product: "Sealed product",
        choose_category: "Choose category / TCG / Sport",
        search_label: "Search the card database",
        search_placeholder: "Card name (e.g. Charizard)",
        api_results: "Database results",
        manual_entry: "Or enter manually",
        no_api_match: "No match? Add it manually.",
        select_card: "Select this card",
        upload_front: "Front image",
        upload_back: "Back image",
        upload_extra: "Additional images",
        upload_drop: "Click to upload (PNG, JPG, WEBP, max 8MB)",
        title_label: "Listing title",
        description_label: "Description",
        price_label: "Price (€)",
        shipping_label: "Shipping cost (€)",
        is_graded: "This card is graded",
        graded_block: "Grading details",
        sealed_block: "Sealed product details",
        review_block: "Review your listing",
        added: "Listing published",
      },
      auth: {
        login_title: "Welcome back",
        register_title: "Create your account",
        email: "Email",
        password: "Password",
        username: "Username",
        confirm_password: "Confirm password",
        google: "Continue with Google",
        or: "or",
        no_account: "No account?",
        have_account: "Already have an account?",
        signup_now: "Sign up",
        login_now: "Log in",
      },
      profile: {
        member_since: "Member since",
        active_listings: "Active listings",
        sold: "Sold",
        bought: "Bought",
        rating: "Rating",
        positive: "Positive",
        neutral: "Neutral",
        negative: "Negative",
        reviews: "Reviews",
        no_reviews: "No reviews yet.",
        write_review: "Write a review",
        leave_review: "Leave a review",
        pending_review_one: "transaction waiting for your review",
        pending_review_many: "transactions waiting for your review",
        pending_review_hint: "Share your experience with @{{name}} to help the community.",
        location: "Location",
        verified: "Verified seller",
      },
      admin: {
        title: "Admin",
        tab_cards: "Cards database",
        tab_reviews: "Reviews",
        tab_users: "Users",
        delete: "Delete",
        hide: "Hide",
        unhide: "Unhide",
        verify: "Verify",
        unverify: "Unverify",
        promote_admin: "Promote to admin",
        demote_user: "Demote to user",
      },
    },
  },
  de: {
    translation: {
      brand: { tagline: "Der Premium-Marktplatz für Karten & versiegelte Sammelobjekte." },
      common: {
        search: "Karten, Sets, Verkäufer suchen...",
        sell: "Verkaufen",
        login: "Anmelden",
        register: "Registrieren",
        logout: "Abmelden",
        profile: "Profil",
        admin: "Admin",
        favorites: "Favoriten",
        loading: "Lädt...",
        save: "Speichern",
        cancel: "Abbrechen",
        apply: "Anwenden",
        clear: "Zurücksetzen",
        next: "Weiter",
        back: "Zurück",
        publish: "Anzeige veröffentlichen",
        all: "Alle",
        yes: "Ja",
        no: "Nein",
        optional: "optional",
        view_all: "Alle anzeigen",
        showing: "{{count}} von {{total}} werden angezeigt",
        no_results: "Keine Anzeigen gefunden. Filter ändern oder andere Suche versuchen.",
        confirm: "Bestätigen",
      },
      nav: { browse: "Marktplatz", sealed: "Sealed", graded: "Gegradet", sports: "Sport", tcg: "TCG" },
      home: {
        hero_kicker: "Cardlon — Marktplatz für Sammler",
        hero_title: "Karten & Sealed-Produkte mit Vertrauen handeln.",
        hero_sub: "Pokémon, Magic, Yu-Gi-Oh!, Lorcana, One Piece, Sportkarten und mehr — verifizierte Verkäufer, echte Bewertungen, transparente Grading-Details.",
        cta_browse: "Marktplatz entdecken",
        cta_sell: "Jetzt verkaufen",
        section_categories: "Kategorien",
        section_featured: "Neueste Anzeigen",
        section_popular: "Beliebte Anzeigen",
        popular_sub: "Am häufigsten gemerkte Anzeigen der Community.",
        no_popular_yet: "Noch keine beliebten Anzeigen. Sei der Erste!",
        no_listings_yet: "Noch keine Anzeigen. Sei der Erste, der eine Karte einstellt!",
        stat_listings: "Aktive Anzeigen",
        stat_users: "Sammler",
        stat_tx: "Abgeschlossene Verkäufe",
      },
      browse: {
        title: "Marktplatz durchsuchen",
        filters: "Filter",
        category: "Kategorie / TCG / Sport",
        any_category: "Alle Kategorien",
        language: "Sprache",
        condition: "Zustand",
        price_range: "Preisspanne (€)",
        graded: "Gegradet",
        grading_firm: "Grading-Firma",
        grade: "Note",
        sealed: "Sealed",
        location: "Standort",
        shipping: "Versand möglich",
        account_type: "Verkäufertyp",
        private: "Privat",
        commercial: "Gewerblich",
        verified_only: "Nur verifizierte Verkäufer",
        sort: "Sortieren",
        sort_newest: "Neueste",
        sort_popular: "Beliebt",
        sort_price_asc: "Preis ↑",
        sort_price_desc: "Preis ↓",
        results: "Treffer",
      },
      card: {
        graded: "Gegradet",
        sealed: "Sealed",
        verified: "Verifiziert",
        case_fresh: "Case Fresh",
        first_ed: "Erstauflage",
        seller: "Verkäufer",
        rating: "Bewertung",
      },
      listing: {
        details: "Details",
        description: "Beschreibung",
        buy: "Jetzt kaufen",
        buy_request: "Kaufanfrage senden",
        contact: "Chat öffnen",
        owner_hint: "Du bist der Verkäufer. Käufer erscheinen hier und du kannst Verkäufe im Chat bestätigen.",
        favorite: "Merken",
        favorited: "Gemerkt",
        shipping_cost: "Versand",
        total: "Gesamt",
        seller_info: "Über den Verkäufer",
        response_time: "Antwortzeit",
        location: "Standort",
        member_since: "Mitglied seit",
        reviews: "Bewertungen",
        positive_pct: "positiv",
        condition: "Zustand",
        language: "Sprache",
        edition: "Edition",
        variant: "Variante",
        year: "Jahr",
        set: "Set",
        number: "Kartennummer",
        rarity: "Seltenheit",
        grading: "Grading",
        grading_firm: "Grading-Firma",
        grade: "Note",
        serial: "Seriennummer",
        cert_link: "Zertifikat",
        slab_condition: "Slab-Zustand",
        label_notes: "Label-Hinweise",
        subgrades: "Subgrades",
        category: "Kategorie",
        product_name: "Produktname",
        quantity: "Menge",
        ean: "EAN / Barcode",
        first_edition: "Erstauflage",
      },
      wizard: {
        title: "Anzeige erstellen",
        quota_used: "Anzeigen diesen Monat",
        quota_premium: "Premium · unbegrenzt",
        upgrade: "Upgraden",
        upgrade_for_more: "Upgrade zu Premium für bis zu 10 Bilder",
        image_limit: "{{used}} / {{max}} Bilder",
        image_limit_reached: "Bilder-Limit erreicht — upgrade für mehr",
        ai_scan_title: "Karte mit KI scannen",
        ai_scan_sub: "Mach ein Foto der Karte oder lade eines hoch. Wir erkennen automatisch Name, Set, Edition, Sprache und Grading-Infos.",
        ai_scan_cta: "Karte fotografieren / hochladen",
        ai_scanning: "Erkenne…",
        step_type: "Typ",
        step_card: "Karte",
        step_grading: "Grading",
        step_images: "Bilder",
        step_price: "Preis & Versand",
        step_review: "Überprüfung",
        choose_type: "Was möchtest du verkaufen?",
        single_card: "Einzelkarte",
        sealed_product: "Sealed-Produkt",
        choose_category: "Kategorie / TCG / Sport wählen",
        search_label: "Kartendatenbank durchsuchen",
        search_placeholder: "Kartenname (z. B. Glurak)",
        api_results: "Datenbank-Ergebnisse",
        manual_entry: "Oder manuell eingeben",
        no_api_match: "Kein Treffer? Manuell anlegen.",
        select_card: "Diese Karte wählen",
        upload_front: "Vorderseite",
        upload_back: "Rückseite",
        upload_extra: "Weitere Bilder",
        upload_drop: "Zum Hochladen klicken (PNG, JPG, WEBP, max. 8MB)",
        title_label: "Titel der Anzeige",
        description_label: "Beschreibung",
        price_label: "Preis (€)",
        shipping_label: "Versandkosten (€)",
        is_graded: "Diese Karte ist gegradet",
        graded_block: "Grading-Details",
        sealed_block: "Sealed-Produkt-Details",
        review_block: "Überprüfe deine Anzeige",
        added: "Anzeige veröffentlicht",
      },
      auth: {
        login_title: "Willkommen zurück",
        register_title: "Account erstellen",
        email: "E-Mail",
        password: "Passwort",
        username: "Benutzername",
        confirm_password: "Passwort bestätigen",
        google: "Mit Google anmelden",
        or: "oder",
        no_account: "Noch kein Konto?",
        have_account: "Bereits ein Konto?",
        signup_now: "Registrieren",
        login_now: "Anmelden",
      },
      profile: {
        member_since: "Mitglied seit",
        active_listings: "Aktive Anzeigen",
        sold: "Verkauft",
        bought: "Gekauft",
        rating: "Bewertung",
        positive: "Positiv",
        neutral: "Neutral",
        negative: "Negativ",
        reviews: "Bewertungen",
        no_reviews: "Noch keine Bewertungen.",
        write_review: "Bewertung schreiben",
        leave_review: "Bewertung abgeben",
        pending_review_one: "Transaktion wartet auf deine Bewertung",
        pending_review_many: "Transaktionen warten auf deine Bewertung",
        pending_review_hint: "Teile deine Erfahrung mit @{{name}} – das hilft der Community.",
        location: "Standort",
        verified: "Verifizierter Verkäufer",
      },
      admin: {
        title: "Admin",
        tab_cards: "Kartendatenbank",
        tab_reviews: "Bewertungen",
        tab_users: "Benutzer",
        delete: "Löschen",
        hide: "Verbergen",
        unhide: "Wieder sichtbar",
        verify: "Verifizieren",
        unverify: "Verifizierung aufheben",
        promote_admin: "Zum Admin machen",
        demote_user: "Zum User machen",
      },
    },
  },
};

const savedLang = (typeof window !== "undefined" && localStorage.getItem("cardlon_lang")) || "de";

i18n.use(initReactI18next).init({
  resources,
  lng: savedLang,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default i18n;
